import { Injectable } from '@angular/core';

import { XsollaService } from '../core/xsolla.service';
import { ApiService, AuthService, LocalStorageService } from '../core/upgraded-providers';

declare const ga: any;
declare const fbq: any;
declare const xnt: any;
declare const mixpanel: any;

interface IPurchaseItem {
    sku: string;
    amount: number;
    quantity: number;
}

const nw = window.nw;

@Injectable()
export class PurchaseService {
    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService,
        private _localStorageSrv: LocalStorageService,

        private _xsollaSrv: XsollaService,
    ) {
    }

    async buy(pkg_type: string, items: any[]): Promise<void | boolean> {
        if (nw) {
            return this._nw(pkg_type, items);
        }

        return this._xsolla(pkg_type, items);
    }

    async _xsolla(pkg_type: string, items: any[]): Promise<boolean> {
        items = items.map(({ sku, quantity }) => ({ sku, amount: quantity }));

        try {
            xnt('send_event', `buy_${ pkg_type }`, { pkg_type });
            mixpanel.track('Order Started', { items });
        } catch (e) {
            console.error(e);
        }

        return new Promise((resolve, reject) => {
            let completed = false;

            this._xsollaSrv.subscribe(() => {
                ga('send', 'event', 'Purchase', pkg_type, '', items);
                fbq('track', 'Purchase', { items });
                mixpanel.track('Order Success', { items });

                completed = true;
            }, (err) => {
                reject(err);
            }, () => {
                this._authSrv.check();

                resolve(completed);
            });

            this._xsollaSrv.next('xsolla/token', { items });
        });
    }

    async _nw(pkg_type: string, items: any[]): Promise<void> {
        const token = this._localStorageSrv.get('auth', null, '');

        const cart = items.map(({ itemdefid: id, quantity: q }) => `${ id }*${ q }`).join(',');
        const cost = items.map(({ price, quantity: q }) => q * price).reduce((a, b) => a + b, 0);

        const apiUrl = this._apiSrv.options.apiUrl;
        // @ts-ignore
        // var greenworks = nw.require('./greenworks');
        // greenworks.activateGameOverlayToWebPage(
        //     `${ apiUrl }steam/cart?_token=${ token }&cart=${ cart }&cost=${ Math.round(100 * cost) }`
        // );

        nw.Shell.openExternal(`${ apiUrl }steam/cart?_token=${ token }&cart=${ cart }&cost=${ Math.round(100 * cost) }`);
    }
}
